import React from "react";
import { Leaf, Star } from "lucide-react";
import Section from "../ui/Section";
import PremiumButton from "../ui/PremiumButton";

const AboutLeafStory = () => {
  return (
    <Section className="py-16 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center">
        {/* Text Content */}
        <div className="lg:col-span-7">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 mb-6">
            <Leaf className="w-3 h-3 text-[#C9A227]" />
            <span className="text-[10px] uppercase tracking-[0.2em] text-white/60">Our Philosophy</span>
          </div>

          <h2 
            className="text-3xl md:text-4xl font-light text-white leading-tight"
            data-testid="about-headline"
          >
            Built with restraint.<br/>
            <span className="text-white/80">Kept wild.</span>
          </h2>
          
          <p className="mt-5 text-base md:text-lg leading-relaxed text-white/70">
            Glow Lawns began as a simple idea: create a place where people can step away 
            from noise and remember what it feels like to simply <em>be</em>. We built around 
            trees, used traditional techniques where possible, and chose comfort that 
            doesn't fight the forest.
          </p>
          
          <p className="mt-4 text-base md:text-lg leading-relaxed text-white/70">
            Come for the moonrise. Stay for the silence.
          </p>

          {/* Value props - calm luxury language */}
          <div className="mt-6 space-y-3">
            <div className="flex items-center gap-3 text-sm text-white/60">
              <Star className="w-4 h-4 text-[#C9A227]" />
              <span>Nature-led experiences—our rhythms follow the forest</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-white/60">
              <Star className="w-4 h-4 text-[#C9A227]" />
              <span>Premium calm, clean comfort—no forced luxury</span>
            </div>
            <div className="flex items-center gap-3 text-sm text-white/60">
              <Star className="w-4 h-4 text-[#C9A227]" />
              <span>Local-first hospitality and sourcing</span>
            </div>
          </div>

          <div className="mt-8">
            <PremiumButton href="/about" variant="secondary">
              Read Our Story
            </PremiumButton>
          </div>
        </div>

        {/* Visual Card */}
        <div className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md">
            {/* Image with cinematic treatment */}
            <div
              className="h-64 md:h-72 bg-cover bg-center"
              style={{
                backgroundImage: "url(https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1800&q=80)",
              }}
            />
            
            {/* Overlay gradient */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
            
            {/* Caption overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="text-xs uppercase tracking-[0.15em] text-[#C9A227] mb-1">The Experience</div>
              <div className="text-sm text-white/90">Where nature becomes your suite</div>
            </div>
          </div>
          
          {/* Tagline card */}
          <div className="mt-4 p-5 rounded-2xl border border-white/10 bg-white/5 text-center">
            <p className="text-sm italic text-white/60">
              "Stillness. Scenery. Serenity."
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default AboutLeafStory;
